/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyModule,
    ReadOnlyModuleFromJSON,
    ReadOnlyModuleFromJSONTyped,
    ReadOnlyModuleToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyModule>}
     * @memberof InlineResponse20020
     */
    results: Array<ReadOnlyModule>;
}

export function InlineResponse20020FromJSON(json: any): InlineResponse20020 {
    return InlineResponse20020FromJSONTyped(json, false);
}

export function InlineResponse20020FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20020 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyModuleFromJSON)),
    };
}

export function InlineResponse20020ToJSON(value?: InlineResponse20020 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyModuleToJSON)),
    };
}


